(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-hulkapps-backup"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  const sticky = document.querySelector('.header-wrapper');
  const header = document.querySelector('.header--has-social');
  const icons = document.querySelectorAll('.header__icon');
  const utilityBar = document.querySelector('.utility-bar ');
  const announcmentBar = document.querySelector('.announcement-bar__message');
  const announcmentBarLink = document.querySelector('.announcement-bar__link ');
  const wkIcon = document.querySelector('.wk-icon');
  const logo = document.querySelector('.header__heading-logo')
  window.onscroll = function() {
    if (window.meta.page.pageType == 'home') {
      if(window.scrollY > 40) {
          // sticky.style.paddingTop = '0px';
          sticky.style.background = 'var(--gradient-background)';
          announcmentBar.style.color = 'rgb(var(--color-foreground))';
          announcmentBarLink.style.borderBottom = 'rgb(var(--color-foreground))';
          icons.forEach(el => el.style.color = 'rgb(var(--color-foreground))');
          logo.style.filter = 'rgb(var(--color-foreground))'
          if (wkIcon.childNodes[1].childNodes[1]) {
            wkIcon.childNodes[1].childNodes[1].style.stroke = 'rgb(var(--color-foreground))';
          } else {
            console.log(wkIcon)
          }
        } else {
          // sticky.style.paddingTop = `${40 - window.scrollY}px`;
          sticky.style.background = 'transparent';
          announcmentBarLink.style.borderBottom = '1px solid var(--gradient-background)';
          sticky.style.borderBottom = '1px solid var(--gradient-background)';
          announcmentBar.style.color = 'var(--gradient-background)';
          icons.forEach(el => el.style.color = 'var(--gradient-background)');
        logo.style.filter = 'brightness(0) saturate(100%) invert(100%) sepia(0%) saturate(7473%) hue-rotate(55deg) brightness(112%) contrast(103%)'
          if (wkIcon.childNodes[1].childNodes[1]) {
              wkIcon.childNodes[1].childNodes[1].style.stroke = 'var(--gradient-background)';
            }
        }
      }
    else {
      // if(window.scrollY > 30) {
      //   sticky.style.paddingTop = '0px';
      // } else {
      //   sticky.style.paddingTop = `${30 - window.scrollY}px`;
      // }
    }
    // if (window.scrollY > 1){
    //   announcmentBar.style.marginTop = '-30px'
    // } else if (windor.scrollY < 30) {
    //   announcmentBar.style.marginTop = '0px'
    // }
  }
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  const sticky = document.querySelector('.header-wrapper');
  const header = document.querySelector('.header--has-social');
  const icons = document.querySelectorAll('.header__icon');
  const utilityBar = document.querySelector('.utility-bar ');
  const announcmentBar = document.querySelector('.announcement-bar__message');
  const announcmentBarLink = document.querySelector('.announcement-bar__link ');
  const wkIcon = document.querySelector('.wk-icon');
  const logo = document.querySelector('.header__heading-logo')
  window.onscroll = function() {
    if (window.meta.page.pageType == 'home') {
      if(window.scrollY > 40) {
          // sticky.style.paddingTop = '0px';
          sticky.style.background = 'var(--gradient-background)';
          announcmentBar.style.color = 'rgb(var(--color-foreground))';
          announcmentBarLink.style.borderBottom = 'rgb(var(--color-foreground))';
          icons.forEach(el => el.style.color = 'rgb(var(--color-foreground))');
          logo.style.filter = 'rgb(var(--color-foreground))'
          if (wkIcon.childNodes[1].childNodes[1]) {
            wkIcon.childNodes[1].childNodes[1].style.stroke = 'rgb(var(--color-foreground))';
          } else {
            console.log(wkIcon)
          }
        } else {
          // sticky.style.paddingTop = `${40 - window.scrollY}px`;
          sticky.style.background = 'transparent';
          announcmentBarLink.style.borderBottom = '1px solid var(--gradient-background)';
          sticky.style.borderBottom = '1px solid var(--gradient-background)';
          announcmentBar.style.color = 'var(--gradient-background)';
          icons.forEach(el => el.style.color = 'var(--gradient-background)');
        logo.style.filter = 'brightness(0) saturate(100%) invert(100%) sepia(0%) saturate(7473%) hue-rotate(55deg) brightness(112%) contrast(103%)'
          if (wkIcon.childNodes[1].childNodes[1]) {
              wkIcon.childNodes[1].childNodes[1].style.stroke = 'var(--gradient-background)';
            }
        }
      }
    else {
      // if(window.scrollY > 30) {
      //   sticky.style.paddingTop = '0px';
      // } else {
      //   sticky.style.paddingTop = `${30 - window.scrollY}px`;
      // }
    }
    // if (window.scrollY > 1){
    //   announcmentBar.style.marginTop = '-30px'
    // } else if (windor.scrollY < 30) {
    //   announcmentBar.style.marginTop = '0px'
    // }
  }
  

  } catch(e) { console.error(e); }
})();
})();
